module.exports = __webpack_public_path__ + "img/logoblue.53d2fb8d.jpg";